import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-parrent-term',
  templateUrl: './parrent-term.component.html',
  styleUrls: ['./parrent-term.component.css']
})
export class ParrentTermComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
